import { useFormContext } from 'react-hook-form';
import { FieldTypeEnum, ICustomField } from 'wisestep-api';
import {
  ControlledTextInput,
  Label,
  WsAutoComplete,
  WsDatePicker,
  WsDateTimePicker,
  WsLocationSearch,
  WsRadioGroup,
  WsSelect,
} from 'wisestep-base';

import RecruiterSuggestions from '../../../components/filters/components/RecruiterSuggestions';
import WsCheckBox from '../../../components/WsCheckBox/WsCheckBox';
import WsCheckmarkSelect from '../../../components/WsCheckmarkSelect';

export default function CustomField({
  type,
  name,
  label,
  required,
  multiple,
  options,
  token,
  auth,
}: ICustomField) {
  const form = useFormContext();
  if (!name || !label || !options) return null;

  return type === FieldTypeEnum.TextBox ? (
    <ControlledTextInput
      name={name}
      type="text"
      fullWidth
      labelText={label}
      variant="outlined"
      inputProps={{}}
      showMandatorySymbol={required}
      size="small"
    />
  ) : type === FieldTypeEnum.Number ? (
    <ControlledTextInput
      fullWidth
      type="number"
      name={name}
      labelText={label}
      inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      showMandatorySymbol={required}
    />
  ) : type === FieldTypeEnum.Date ? (
    <>
      <Label>{`${label} ${required ? '*' : ''}`}</Label>
      <WsDatePicker name={name} label="" required={required} />
    </>
  ) : type === FieldTypeEnum.Location ? (
    <WsLocationSearch
      size="medium"
      placeHolder={label}
      name={name}
      variant="outlined"
      multiSelect={false}
      wisestepApi={true}
      token={token}
      authorization={auth}
    />
  ) : type === FieldTypeEnum.DateAndTime ? (
    <>
      <Label>{`${label} ${required ? '*' : ''}`}</Label>
      <WsDateTimePicker name={name} label="" size="medium" required={required} />
    </>
  ) : type === FieldTypeEnum.URL ? (
    <ControlledTextInput
      name={name}
      type="text"
      fullWidth
      labelText={label}
      variant="outlined"
      showMandatorySymbol={required}
    />
  ) : type === FieldTypeEnum.Dropdown ? (
    multiple ? (
      <>
        <Label>{`${label} ${required ? '*' : ''}`}</Label>
        <WsCheckmarkSelect
          name={name}
          options={options?.map((opt) => ({ label: opt, value: opt })) ?? []}
          getLabel={(option) => option.label}
        />
      </>
    ) : (
      <WsSelect
        name={name}
        label={label}
        selectArray={options?.map((label) => ({ label, value: label })) as []}
        showMandatorySymbol={required}
      />
    )
  ) : type === FieldTypeEnum.Checkbox ? (
    options.length === 0 ? (
      <WsCheckBox name={name} label={label} />
    ) : (
      <>
        <Label>{`${label} ${required ? '*' : ''}`}</Label>
        <WsRadioGroup
          name={name}
          required={required}
          selectArray={options.map((label) => ({ label, value: label }))}
        />
      </>
    )
  ) : type === FieldTypeEnum.Users ? (
    <>
      <Label>{`${label} ${required ? '*' : ''}`}</Label>
      <RecruiterSuggestions name={name} multiple={false} defaultValue={form.getValues(name)} />
    </>
  ) : type === FieldTypeEnum.Tags ? (
    <WsAutoComplete
      onTagsChange={(selectedTags) => {
        form.setValue(name, selectedTags ?? []);
      }}
      placeholder="Enter Tags, comma seprated"
      initialValue={form.getValues(name)}
      multiple={true}
      freeSolo={true}
      name={name}
      label={label}
      size="small"
      variant="outlined"
      showMandatorySymbol={required}
    />
  ) : null;
}
